<div [@inbgOutAnimation] class="load-wrapper" [ngClass]="{'modal-loader': modalloader}">
    <div class="load-bg"></div>
    <div [@inbgOutAnimation] class="load-content">
        <span *ngIf="!modalloader" class="material-icons f-45 {{iconclass}}">
            {{icon}}
        </span>
        <span *ngIf="modalloader" class="loader-css"></span>
        <p class="f-15 font-weight-bold">{{text}}</p>
    </div>
</div>




<ng-container *ngIf="testloader">
    <div [@inbgOutAnimation] class="load-wrapper">
        <div class="load-bg-test">
        </div>
        <div [@inbgOutAnimation] class="load-content">
            <span class="material-icons f-45 {{iconclass}}">
                {{icon}}
            </span>
            <p class="f-15 font-weight-bold">{{text}}</p>
        </div>
    </div>
</ng-container>